import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { RequestOptions, Headers } from '@angular/http';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { AppAuthHttpService } from '../../http/app.auth.http.service';
import { GlobalTaxResponse, TaxResponse } from '../models/TaxResponse';
import { TaxRequest } from '../models/TaxRequest';

@Injectable()
export class TaxDeterminationService {

  private baseUrl: string = this.environment.baseUrl + '/api/tax-determination';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  healthTDS(): Observable<boolean> {
    const url = `${this.baseUrl}/health?type=TAX`;
    return this.http.get(url)
      .map((response) => {
        return response.json() as TaxResponse;
      })
      .catch((error: any) => {
        this.responseUtilService.handleError(error);
        return Observable.throw(error);
      });
  }

  getTaxRate(eventId: number): Observable<GlobalTaxResponse> {

    const url = `${this.baseUrl}/${eventId}/taxrate`;
    return this.http.get(url)
      .map((response) => {
        return response.json() as GlobalTaxResponse;
      })
      .catch((error: any) => {
        this.responseUtilService.handleError(error);
        return Observable.throw(error);
      });
  }

  verifyTaxRate(taxRequest: TaxRequest): Observable<GlobalTaxResponse> {
    const options = new RequestOptions({headers: new Headers({'Content-Type': 'application/json'})});
    const url = `${this.baseUrl}/taxrate/verify`;
    return this.http.post(url, taxRequest, options)
      .map((response) => {
        return response.json() as GlobalTaxResponse;
      })
      .catch((error: any) => {
        this.responseUtilService.handleError(error);
        return Observable.throw(error);
      });
  }

  getTaxRateByParty(eventId: number, eventPartyId: number): Observable<GlobalTaxResponse> {

    const url = `${this.baseUrl}/${eventId}/${eventPartyId}/taxrate`;
    return this.http.get(url)
      .map((response) => {
        return response.json() as GlobalTaxResponse;
      })
      .catch((error: any) => {
        this.responseUtilService.handleError(error);
        return Observable.throw(error);
      });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/tax-determination.http.service.ts